import config from 'constants/config'
import getPaymentMethods from 'lib/payment/getPaymentMethods'
import isSafari from 'lib/web/isSafari'
import {
  APPLE_PAY_PAYMENT_TYPE,
} from 'constants/payment'

const isMacOSDevice = typeof navigator !== 'undefined' && (
  (
    /Macintosh|Mac OS X/.test(navigator.userAgent) ||
    navigator.platform === 'MacIntel'
  ) &&
  navigator.maxTouchPoints <= 1
)

// Detect any iOS/iPadOS device (all browsers on iOS use WebKit and support Apple Pay)
const isIOSDevice = typeof navigator !== 'undefined' && (
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
)

/** Original narrow check — Apple devices only. */
export const isApplePayEnabled = (currency: string): boolean => !!(
  config.APPLE_PAY_ENABLED &&
  getPaymentMethods(currency).includes(APPLE_PAY_PAYMENT_TYPE) &&
  (isIOSDevice || isMacOSDevice)
)

/**
 * Broadened check — all iOS/iPadOS browsers + macOS Safari.
 * All iOS browsers use WebKit under the hood and support Apple Pay natively.
 * Used when the express checkout experiment is active so the broadened
 * availability can be rolled back by turning off the experiment.
 */
export const isApplePayEnabledBroadened = (currency: string): boolean => !!(
  config.APPLE_PAY_ENABLED &&
  getPaymentMethods(currency).includes(APPLE_PAY_PAYMENT_TYPE) &&
  (isIOSDevice || isSafari)
)
